import styled from 'styled-components';

export const ViewWrapper = styled.div`
    font-size: 14px;
    line-height: 25px;
`;

export const LineItem = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    padding-bottom: 6px;
    flex-wrap: wrap;
`;

export const ItemLabel = styled.div``;
export const Price = styled.div``;
export const LineItemSubText = styled.p`
    margin: 0;
`;
